import script from "./ArticleImageManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleImageManager.vue?vue&type=script&setup=true&lang=js"

import "./ArticleImageManager.vue?vue&type=style&index=0&id=9f36278a&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f36278a"]])

export default __exports__